<template>
  <div>
    <div id="mapDiv" ref="mapDiv"></div>
    <!-- 弹窗元素 -->
    <div class="popup" ref="popup" v-show="currentCoordinate">
      <div @touchstart="closePopup" @click="closePopup" class="icon-close">×</div>
      <div class="content" ref="popupContent">{{ currentCoordinate }}</div>
    </div>
  </div>
</template>

<script>
import "ol/ol.css";
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Overlay from 'ol/Overlay';
import {Icon, Style, Text} from 'ol/style';
import {Vector as VectorLayer} from "ol/layer";
import {Vector as VectorSource} from "ol/source";
import mapConfig from "@/assets/js/mapconfig";
import {Map, View} from "ol";
import 'ol/ol.css';
import {toStringHDMS} from 'ol/coordinate'
import {toLonLat} from 'ol/proj'
import {defaults as defaultControls} from "ol/control";
import {defaults as defaultInteractions, DragRotateAndZoom,} from 'ol/interaction';
import Fill from "ol/style/Fill";
import FullScreen from "ol/control/FullScreen";
import Zoom from "ol/control/Zoom";
import {getSpaceTree} from "@/network/space-info";
import {getSystematicByCodes} from "@/network/systematic";
import areaGeo from "@/assets/mapJson/210106.json";
import MultiPolygon from "ol/geom/MultiPolygon";
import Polygon from "ol/geom/Polygon";
import Stroke from "ol/style/Stroke";
import {getSpaceAlarmIds} from "@/network/alarm-realtime";

export default {
  name: "TDMap",
  data() {
    return {
      map: '',
      spaceTreeData: [],
      icon: require('../../../../assets/images/icon/map.png'),
      alarmIcon: require('../../../../assets/images/icon/alarmMap.png'),
      schoolIcon: require('../../../../assets/images/icon/school.png'),
      alarmSchoolIcon: require('../../../../assets/images/icon/alarmSchool.png'),
      features: [],
      vectorSource: null,
      clusterSource: null,
      townMarker: [],
      schoolMaker: [],
      overlay: null,
      currentCoordinate: null, // 弹窗坐标数据
      hoverFeature: null,
      level: 0,
      alarmSpaceIds: [],
    }
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'editIcon')
  },
  mounted() {
    this.getSystematicByCodes()

    setTimeout(() => {
      this.$store.dispatch('addIntervalObj', {'editIcon:5000': this.getSpaceAlarmIds})
    }, 5000)
  },
  methods: {
    getSystematicByCodes() {
      getSystematicByCodes("space_level_code").then(res => {
        if ( res.code === 0 ) {
          if ( res.data !== null && res.data.length > 0 ) {
            this.level = parseInt(res.data[0].val2) + 1
            this.getSpaceAlarmIds(true);
          }
        }
      })
    },
    //获取告警标识
    getSpaceAlarmIds(init) {
      getSpaceAlarmIds().then(res => {
        this.alarmSpaceIds = res.data.spaceIdList
        if ( init ) {
          this.getSpaceTree();
        } else {
          // 定时获取告警,更改图标
          this.initData(init);
        }
      })
    },
    getSpaceTree() {
      // console.log("级别："+this.level)
      getSpaceTree(this.level).then(res => {
        if ( res.code === 0 ) {
          this.spaceTreeData = res.data
          let data = this.initData(true)
          this.townMarker = data
          let marker = []
          data.forEach(item => {
            marker = marker.concat(item.spaceInfos)
          })
          this.schoolMaker = marker
        }
        this.initMap();
        this.addArea(areaGeo);
      })
    },
    // 初始化数据
    initData(init) {
      if ( this.alarmSpaceIds.length > 0 ) {
        return this.spaceTreeData.map(item => {
          let alarmCount = 0;
          if ( item.spaceInfos.length > 0 ) {
            item.spaceInfos.map(space => {
              this.alarmSpaceIds.forEach(spaceId => {
                if ( space.id === spaceId ) {
                  alarmCount = alarmCount++;
                  space.status = 1; //告警
                  item.status = 1;
                }
              })
              //定时修改空间告警图标
              if ( !init ) {
                let feature = this.vectorSource.getFeatureById(space.id)
                if ( feature ) {
                  this.setAlarmIcon(feature, false, space.status)
                }
              }
              return space
            })
          }
          item.alarmCount = alarmCount
          //定时修改数量告警图标
          if ( !init ) {
            let feature = this.vectorSource.getFeatureById(item.id)
            if ( feature ) {
              this.setAlarmIcon(feature, true, item.status)
            }
          }
          return item
        })
      } else {
        return this.spaceTreeData
      }
    },
    initMap() {
      let mapContainer = this.$refs.mapDiv;
      this.map = new Map({
        target: mapContainer,
        interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
        layers: [mapConfig.streetMap("img"), mapConfig.streetMap("cia")],
        overlays: [],
        view: new View({
          projection: "EPSG:4326",    //使用这个坐标系
          center: [mapConfig.x, mapConfig.y],
          zoom: mapConfig.zoom,
          maxZoom: mapConfig.maxZoom,
          minZoom: mapConfig.minZoom,
        }),
        controls: defaultControls({
          rotate: true,
        }).extend([
          new FullScreen({
            tipLabel: "全屏"
          }),
          new Zoom({
            zoomInTipLabel: "放大",
            zoomOutTipLabel: "缩小"
          })
        ])
      });
      this.mapClick();
      this.mapOver()
      this.changeZoom();
    },
    //区域描边
    addArea(geo = []) {
      if ( geo.length === 0 ) {
        return false;
      }
      let features = [];
      geo.forEach((g) => {
        let lineData = g.features[0];
        let routeFeature = "";
        console.log(lineData.geometry.type);
        if ( lineData.geometry.type === "MultiPolygon" ) {
          routeFeature = new Feature({
            geometry: new MultiPolygon(lineData.geometry.coordinates),
          });
        } else if ( lineData.geometry.type === "Polygon" ) {
          routeFeature = new Feature({
            geometry: new Polygon(lineData.geometry.coordinates),
          });
        }
        routeFeature.setStyle(
          new Style({
            fill: new Fill({
              color: [11, 53, 93, .3], //填充颜色
            }),
            stroke: new Stroke({
              width: 3, //边界宽度
              color: [7, 230, 248, 1], //边界颜色
            }),
          })
        );
        features.push(routeFeature);
      });
      // 设置图层
      let routeLayer = new VectorLayer({
        source: new VectorSource({
          features: features,
        }),
      });
      // 添加图层
      this.map.addLayer(routeLayer);
    },

    //地图点击
    mapClick() {
      const _this = this
      // 通过 map.on() 监听, singleclick 是单击的意思. 也可以用 click 代替 singleclick.
      this.map.on('singleclick', evt => {
        const coordinate = evt.coordinate // 获取坐标
        // console.log("当前坐标地点："+evt.coordinate)
        const hdms = toStringHDMS(toLonLat(coordinate)) // 转换坐标格式
        this.currentCoordinate = hdms // 保存坐标点

        var feature = _this.map.forEachFeatureAtPixel(evt.pixel,
          function (feature) {
            return feature
          })
        if ( feature ) {
          //点击图标内容显示
          var coordinates = feature.getGeometry().getCoordinates()
          if ( feature.id_ && feature.content !== undefined ) {
            //点击学校图标
            let spaceInfo = {id: feature.id_, title: feature.name}
            this.$cookies.set("currentSpaceInfo", JSON.stringify(spaceInfo))
            // this.$router.push("/overview")
            // this.$emit('display','list',{id: feature.id_, title: feature.name})
            this.$emit('display', 'indoor')
          } else if ( feature.id_ && feature.content === undefined ) {
            //点击数量图标
            _this.map.getView().setZoom(mapConfig.streetZoom) //放到到镇级别
            _this.map.getView().setCenter(coordinates) //中心点改变
          }
        }
      })
    },
    //鼠标悬停
    mapOver: function () {
      const _this = this
      this.map.on('pointermove', evt => {
        // 手指效果
        var pixel = _this.map.getEventPixel(evt.originalEvent);
        var hit = _this.map.hasFeatureAtPixel(pixel);
        // 高亮区域取消手指效果
        const hoverFeature = _this.map.getFeaturesAtPixel(pixel);
        _this.map.getTarget().style.cursor = hit && hoverFeature.length > 1 ? 'pointer' : '';

        var feature = _this.map.forEachFeatureAtPixel(evt.pixel,
          function (feature) {
            return feature
          })
        if ( feature !== undefined ) {
          if ( feature.name && feature.id_ ) {
            //鼠标移入更改值
            this.hoverFeature = _this.vectorSource.getFeatureById(feature.id_)
            let styles = this.hoverFeature.style_;
            let text = styles[2].text_
            text.text_ = feature.name
            _this.vectorSource.changed()
          } else {
            //鼠标移出更改值
            if ( this.hoverFeature ) {
              const styles = this.hoverFeature.style_;
              const text = styles[2].text_
              text.text_ = ""
              _this.vectorSource.changed()
              this.hoverFeature = null;
            }
          }
        }
      })
    },
    //级别变化
    changeZoom() {
      const that = this
      this.map.on('moveend', function () {
        const zoom = that.map.getView().getZoom();  //获取当前地图的缩放级别
        if ( zoom < mapConfig.streetZoom ) { //初始化级别
          that.map.removeLayer(that.clusterSource)
          that.initTownMarkerIcon(that.townMarker);
        } else if ( zoom >= mapConfig.streetZoom ) { //街道
          that.map.removeLayer(that.clusterSource)
          that.initMarkerIcon(that.schoolMaker);
        }
      })
    },

    //初始化数量图标
    initTownMarkerIcon(iconMaker) {
      this.features = []
      if ( iconMaker.length > 0 ) {
        //空间设备标识图层经纬度 lng ,lat
        iconMaker.forEach(item => {
          if ( item.lng && item.lat ) {
            // console.log("===================")
            // console.log(item.lng+"---"+item.lat)
            let marker = new Feature({
              geometry: new Point([item.lng, item.lat]),
            });
            marker.setStyle([
              new Style({
                image: new Icon({
                  // anchor: [0.5, 74],//偏移量
                  anchorXUnits: 'fraction',
                  anchorYUnits: 'pixels',
                  src: item.status ? this.alarmIcon : this.icon,
                }),
              }),
              new Style({
                text: new Text({
                  text: item.count.toString(),
                  scale: 1.2,
                  font: "14px Microsoft YaHei",
                  offsetY: "40",
                  fill: new Fill({
                    color: '#fff'
                  })
                }),
              }),
              new Style({
                text: new Text({
                  text: "",//marker提示
                  font: "14px Microsoft YaHei",
                  offsetY: "80",
                  padding: [5, 10, 5, 10],
                  backgroundFill: new Fill({
                    color: "rgba(255,255,255,.7)"//提示背景色
                  }),
                  fill: new Fill({
                    color: "#000"
                  }),
                })
              })
            ])
            marker.id_ = item.id;
            marker.name = item.name;
            marker.count = item.count;
            this.features.push(marker)
          }
        })
        this.initOverlay();
      }
    },
    //初始化图标
    initMarkerIcon(iconMaker) {
      this.features = []
      if ( iconMaker.length > 0 ) {
        iconMaker.forEach(item => {
          if ( item.longitude && item.latitude ) {
            let marker = new Feature({
              geometry: new Point([item.longitude, item.latitude]),
            });
            marker.setStyle([
              new Style({
                image: new Icon({
                  anchor: [0.5, 66],//偏移量
                  anchorXUnits: 'fraction',
                  anchorYUnits: 'pixels',
                  src: item.status ? this.alarmSchoolIcon : this.schoolIcon,
                }),
              }),
              new Style({
                text: new Text({
                  text: "",
                  font: "14px Microsoft YaHei",
                  offsetY: "40",
                  fill: new Fill({
                    color: '#fff'
                  })
                }),
              }),
              new Style({
                text: new Text({
                  text: "",//marker提示
                  font: "14px Microsoft YaHei",
                  offsetY: "30",
                  padding: [5, 10, 5, 10],
                  backgroundFill: new Fill({
                    color: "rgba(255,255,255,.7)"//提示背景色
                  }),
                  fill: new Fill({
                    color: "#000"
                  }),
                })
              })
            ])
            marker.id_ = item.id;
            marker.name = item.cnName;
            //窗口内容
            // const id = item.id
            const name = item.cnName
            // // 创建信息窗口对象
            const content = '<div style="font-size: 1.8rem;cursor: pointer;color: #fff;font-weight: bold;padding-right: 20px;">' + name + '</div>'
            marker.content = content
            this.features.push(marker)
          }
        })
        this.initOverlay();
      }
    },

    //设置告警/正常图标
    //图标,是否是分区数量图标,是否告警
    setAlarmIcon(feature, distribute, alarm) {
      feature.style_[0] = new Style({
        image: new Icon({
          // anchor: [0.5, 74],//偏移量
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: distribute ? (alarm ? this.alarmIcon : this.icon) : (alarm ? this.alarmSchoolIcon : this.schoolIcon),
        }),
      })
      this.vectorSource.changed()
    },


    initOverlay() {
      this.overlay = new Overlay({
        element: this.$refs.popup, // 弹窗标签, 在 html 里
        autoPan: true, // 如果弹窗在底图边缘时, 底图会移动
        autoPanAnimation: { // 底图移动动画
          duration: 250
        }
      });
      // 矢量要素数据源
      this.vectorSource = new VectorSource({
        features: this.features,
      });
      // 聚合标注数据源
      this.clusterSource = new VectorLayer({
        distance: 0, //这个是通过 distance 来控制两个点聚合的间距
        source: this.vectorSource,
      });
      this.map.addLayer(this.clusterSource)
      this.map.addOverlay(this.overlay)
    },
    // 关闭信息框
    closePopup() {
      // 把弹窗位置设置为 undefined, 并清空坐标数据
      this.overlay.setPosition(undefined)
      this.currentCoordinate = null
    },
  }
}
</script>

<style scoped>
#mapDiv {
  height: 100vh;
  width: 100%;
}

/* 弹窗样式 */
.popup {
  background-color: rgba(43, 52, 49, .8);
  min-width: 280px;
  position: relative;
  padding: 10px 16px;
  cursor: pointer;
  color: #fff;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  transform: translate(-50%, calc(-100% - 12px));
}

/* 弹窗下方的小三角形 */
.popup::after {
  display: block;
  content: '';
  width: 0;
  height: 0;
  position: absolute;
  border: 12px solid transparent;
  border-top-color: rgba(43, 52, 49, .8);
  bottom: -23px;
  left: 50%;
  transform: translateX(-50%);
}

/* 关闭弹窗按钮 */
.icon-close {
  position: absolute;
  color: #fff;
  cursor: pointer;
  align-self: flex-end;
  margin-bottom: 10px;
}
</style>
